module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/chapel_01-e21c9c3beeac27200fda6ffb9093f333.jpg";